import Vue from 'vue'
import pluginInstall from './plugin'
import { install as apiInstall } from '@/api'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App'
import store from './store'
import './style/index.scss'
import './style/element-variables.scss'
import '@shopex/finder/lib/finder.css'
import { initFinder } from '@shopex/finder'
import finderGloub from '@/config/finderGloub'
import { Tracker } from '@/service'
import noSAAS from '@/mixin/noSAAS'
import getStoreOrGuide from '@/mixin/getStoreOrGuide'

// import 'vueloopscroll/lib/vueloopscroll.css';
Vue.mixin({
  ...noSAAS
})
Tracker.use()
Tracker._tracker.init()
apiInstall(Vue)

Vue.use(pluginInstall)
initFinder(Vue, finderGloub)

import router from './router'
const update = Vue.prototype._update
Vue.prototype._update = function (node) {
  // if (node.context._uid > 532 && node.context._uid < 600) {
  //   console.log('_update-node', node)
  // }
  update.call(this, ...arguments)
}
Vue.config.productionTip = false
new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
